module.exports = __webpack_public_path__ + "static/logo_small-b93c3bea2ee3e8ffe631ba64ef8ece4f.svg";